import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { styled } from "@mui/material/styles";

import {
  Typography,
  FormControl,
  FormControlLabel,
  MenuItem,
  Switch,
  Select,
  Grid,
  Box,
  Radio,
  RadioGroup,
  ToggleButton,
  ToggleButtonGroup,
  Divider,
} from "@mui/material";

import DatePickerCustom from "../../../../shared/date/datePicker";
import ButtonBlue from "../../../../shared/general/ButtonBlue";
import MonthPanel from "./month-panel";
import { useTranslation } from "react-i18next";
import { updatePayrollDateCustom } from "../../../../../../actions/paytypes";

const StyledRoot = styled("div")({
  "&.wrap-item-data": {
    // marginLeft: 16,
    // marginBottom: 8,
  },
  "& .item-name": {
    fontWeight: 600,
    marginBottom: 4,
    "&.disabled": {
      color: "#DDD",
    },
  },
  "& .MuiToggleButton-root": {
    padding: "8px 16px;",
  },
});

const StyledFormControl = styled(FormControl)({
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: 8,
    "& .MuiOutlinedInput-input": {
      padding: "13.5px 14px",
    },
    "& .MuiInputBase-inputMultiline": {
      padding: 0,
    },
  },
});

const StyledFormControlLabelSwitch = styled(FormControlLabel)({
  marginRight: 0,
});

const StyledDividerDashed = styled(Divider)({
  margin: "16px 0px",
  borderWidth: "0px 0px thin",
  borderColor: "rgba(145, 158, 171, 0.24)",
  borderStyle: "dashed",
  width: "100%",
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const timePayslip = [
  "00:00",
  "01:00",
  "02:00",
  "03:00",
  "04:00",
  "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00",
];

const RoundOne = (props) => {
  const { t, i18n } = useTranslation();
  const { dataForm, handleOnChangeData, selectedPaymentType } = props;
  const dispatch = useDispatch();
  const today = dayjs().toDate();
  const { result: userProfile } = useSelector((state) => state.userProfile);
  const { result: payrollSettingList } = useSelector(
    (state) => state.payrollSetting,
  );
  const payrollSetting =
    payrollSettingList && payrollSettingList.length > 0
      ? payrollSettingList[0]
      : null;
  const [payDateYearList, setPayDateYearList] = useState(null);
  const [paymentRoundData, setPaymentRoundData] = useState(null);
  const [round, setRound] = React.useState(1);

  useEffect(() => {
    let payDate = [];
    for (let index = -2; index < 3; index++) {
      payDate.push(dayjs(today).add(index, "year").format("YYYY"));
    }

    setPayDateYearList(payDate);
  }, []);

  const [dateCustom, setDateCustom] = useState(null);

  useEffect(() => {
    if (payrollSetting && userProfile) {
      const payrollDateCustom = payrollSetting.payrollDateCustom || [];
      let temp = [];
      for (let index = 0; index < 12; index++) {
        let find = payrollDateCustom.find(
          (x) =>
            x.year === parseInt(dayjs().format("YYYY")) && x.month === index,
        );

        if (find) {
          temp.push(find);
        } else {
          temp.push({
            year: dayjs().format("YYYY"),
            round: 1,
            month: index,
            payDate: null,
            payslipDate: null,
            payslipTime: payrollSetting.firstPayslipTime,
            idCompany: userProfile.idCompany,
          });
        }
      }

      setDateCustom(temp);
      let temp2 = (payrollSetting.paymentTypeRound || []).find(
        (x) =>
          x.round === parseInt(dataForm.paymentRound) &&
          x.idPaymentType === selectedPaymentType.id,
      );

      if (temp2 && temp2.paysilpPublicType === "custom") {
        temp2.settingYear =
          payrollDateCustom.length > 0
            ? payrollDateCustom[0].year
            : parseInt(dayjs().format("YYYY"));
      }

      setPaymentRoundData(temp2 || null);
    }
  }, [payrollSetting]);

  useEffect(() => {
    if (payrollSetting) {
      const payrollDateCustom = payrollSetting.payrollDateCustom || [];
      let temp2 = (payrollSetting.paymentTypeRound || []).find(
        (x) =>
          x.round === parseInt(dataForm.paymentRound) &&
          x.idPaymentType === selectedPaymentType.id,
      );

      if (temp2 && temp2.paysilpPublicType === "custom") {
        temp2.settingYear =
          payrollDateCustom.length > 0
            ? payrollDateCustom[0].year
            : parseInt(dayjs().format("YYYY"));
      }

      setPaymentRoundData(temp2 || null);
    }
  }, [dataForm, selectedPaymentType]);

  const handleChangeDateSetting = (data) => {
    let temp = [...dateCustom];
    temp[data.index][data.name] = data.value;
    setDateCustom(temp);
  };

  const handleOnClickSaveCustomDate = async () => {
    const result = await dispatch(updatePayrollDateCustom(dateCustom));
  };

  const handleOnClickChangePaysilpPublicType = (event) => {
    const { name, value } = event.target;
    setPaymentRoundData({ ...paymentRoundData, [name]: value });
  };

  const handleChangeRound = (event, newValue) => {
    handleOnChangeData(event);
  };

  return (
    <StyledRoot className="wrap-item-data">
      {paymentRoundData !== null && payrollSetting ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box>
              <Typography style={{ fontWeight: 600 }} variant="body1">
                {`${t("RoundSetting")} ...`}
              </Typography>
              <ToggleButtonGroup
                size="small"
                value={paymentRoundData.round}
                onChange={handleChangeRound}
                exclusive={true}
                aria-label="Small sizes"
                name="round"
              >
                <ToggleButton value={1} key="1">
                  1
                </ToggleButton>
                <ToggleButton
                  value={2}
                  key="2"
                  disabled={parseInt(paymentRoundData.round) < 2}
                >
                  2
                </ToggleButton>
                <ToggleButton
                  value={3}
                  key="3"
                  disabled={parseInt(paymentRoundData.round) < 3}
                >
                  3
                </ToggleButton>
                <ToggleButton
                  value={4}
                  key="4"
                  disabled={parseInt(paymentRoundData.round) < 4}
                >
                  4
                </ToggleButton>
              </ToggleButtonGroup>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box>
              <Typography style={{ fontWeight: 600 }} variant="body1">
                {t("WorkingDays")}
              </Typography>
              <div className="wrap-item-data">
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="round-payroll"
                    name="workingDay"
                    value={paymentRoundData.workingDay}
                    //onChange={handleOnChangeData}
                  >
                    <FormControlLabel
                      value={28}
                      control={
                        <Radio disabled={paymentRoundData.workingDay !== 28} />
                      }
                      label={`28 ${t("Days")}`}
                    />
                    <FormControlLabel
                      value={29}
                      control={
                        <Radio disabled={paymentRoundData.workingDay !== 29} />
                      }
                      label={`29 ${t("Days")}`}
                    />
                    <FormControlLabel
                      value={30}
                      control={
                        <Radio disabled={paymentRoundData.workingDay !== 30} />
                      }
                      label={`30 ${t("Days")}`}
                    />
                    <FormControlLabel
                      value={-1}
                      control={
                        <Radio disabled={paymentRoundData.workingDay !== -1} />
                      }
                      label={t("ActualNumberOfDays")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography className="item-name">{t("SalaryRound")}</Typography>
            <StyledFormControl fullWidth>
              <Select
                inputProps={{ readOnly: true }}
                MenuProps={MenuProps}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="firstCutRoundDate"
                value={paymentRoundData.cutRoundDate}
              >
                <MenuItem key={99} value={-1}>
                  {t("LastDayOfMonth")}
                </MenuItem>
                {[...Array(29).keys()].map((item) => (
                  <MenuItem key={item} value={item + 1}>
                    {item + 1}
                  </MenuItem>
                ))}
              </Select>
            </StyledFormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Typography
              className={`item-name ${
                paymentRoundData.cutRoundStaticDate === null ? "disabled" : ""
              }`}
            >
              {t("StatisticRound")}
            </Typography>
            <StyledFormControl fullWidth>
              <Select
                inputProps={{ readOnly: true }}
                disabled={paymentRoundData.cutRoundStaticDate === null}
                MenuProps={MenuProps}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="cutRoundStaticDate"
                value={paymentRoundData.cutRoundStaticDate}
              >
                <MenuItem key={99} value={-1}>
                  {t("LastDayOfMonth")}
                </MenuItem>
                <MenuItem key={999} value={0}>
                  {t("cutOffPeriod")}
                </MenuItem>
                {[...Array(29).keys()].map((item) => (
                  <MenuItem key={item} value={item + 1}>
                    {item + 1}
                  </MenuItem>
                ))}
              </Select>
            </StyledFormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className="wrap-label-switch">
              <Typography className="item-name">{`${t("OT")}/${t(
                "ShiftFee"
              )}`}</Typography>
            </div>

            <StyledFormControl fullWidth>
              <Select
                inputProps={{ readOnly: true }}
                MenuProps={MenuProps}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="roundOT"
                value={paymentRoundData.roundOT}
              >
                <MenuItem key={1} value={"now"}>
                  {t("FollowSalaryRound")}
                </MenuItem>
                <MenuItem key={2} value={"previous"}>
                  {t("OneMonthBack")}
                </MenuItem>
                <MenuItem key={3} value={"static"}>
                  {t("FollowStatisticRound")}
                </MenuItem>
              </Select>
            </StyledFormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className="wrap-label-switch">
              <Typography className="item-name">
                {t("Late")}/{t("Absent")}
              </Typography>
            </div>

            <StyledFormControl fullWidth>
              <Select
                inputProps={{ readOnly: true }}
                MenuProps={MenuProps}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="roundLateAbsentLeave"
                value={paymentRoundData.roundLateAbsentLeave}
              >
                <MenuItem key={1} value={"now"}>
                  {t("FollowSalaryRound")}
                </MenuItem>
                <MenuItem key={2} value={"previous"}>
                  {t("OneMonthBack")}
                </MenuItem>
                <MenuItem key={3} value={"static"}>
                  {t("FollowStatisticRound")}
                </MenuItem>
              </Select>
            </StyledFormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className="wrap-label-switch">
              <Typography className="item-name">
                {t("CutOffApprovalRound")}
              </Typography>
              <StyledFormControlLabelSwitch
                checked={paymentRoundData.cutApproveNextMonth}
                control={<Switch size="small" />}
                label={t("NextMonth")}
                labelPlacement="nextMonth"
              />
            </div>

            <StyledFormControl fullWidth>
              <Select
                inputProps={{ readOnly: true }}
                MenuProps={MenuProps}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="cutApproveDate"
                value={paymentRoundData.cutApproveDate}
              >
                {[...Array(31).keys()].map((item) => (
                  <MenuItem key={item} value={item + 1}>
                    {item + 1}
                  </MenuItem>
                ))}
              </Select>
            </StyledFormControl>
          </Grid>
          <Grid item xs={12} sm={3}>
            <div className="wrap-label-switch">
              <Typography className="item-name">
                {t("PayDateFormat")}
              </Typography>
            </div>
            <StyledFormControl fullWidth>
              <Select
                MenuProps={MenuProps}
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="paysilpPublicType"
                value={paymentRoundData.paysilpPublicType}
                onChange={handleOnClickChangePaysilpPublicType}
              >
                <MenuItem key={"1"} value={"auto"}>
                  {t("Automatic")}
                </MenuItem>
                <MenuItem key={"2"} value={"custom"}>
                  {t("CustomDefined")}
                </MenuItem>
              </Select>
            </StyledFormControl>
          </Grid>
          {paymentRoundData.paysilpPublicType === "custom" && (
            <Fragment>
              <Grid item xs={12} sm={3}>
                <div className="wrap-label-switch">
                  <Typography className="item-name">
                    {t("AnnualSetting")}
                  </Typography>
                </div>
                <StyledFormControl fullWidth>
                  <Select
                    MenuProps={MenuProps}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="settingYear"
                    value={paymentRoundData.settingYear}
                    onChange={handleOnChangeData}
                  >
                    <MenuItem key={"1"} value={2024}>
                      2024
                    </MenuItem>
                    <MenuItem key={"2"} value={2025}>
                      2025
                    </MenuItem>
                  </Select>
                </StyledFormControl>
              </Grid>
              <Grid item xs={12} sm={3}>
                <Typography className="item-name">
                  {t("PayslipReleaseTime")}
                </Typography>
                <StyledFormControl fullWidth>
                  <Select
                    inputProps={{ readOnly: true }}
                    MenuProps={MenuProps}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="paysilpPublicTime"
                    value={paymentRoundData.paysilpPublicTime}
                  >
                    {timePayslip.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledFormControl>
              </Grid>
              <Grid item xs={12}>
                {dateCustom.map((item) => (
                  <MonthPanel
                    item={item}
                    handleOnChange={handleChangeDateSetting}
                  />
                ))}
              </Grid>
              <Grid item xs={12}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <ButtonBlue
                    variant="contained"
                    onClick={handleOnClickSaveCustomDate}
                  >
                    {t("Save")}
                  </ButtonBlue>
                </div>
                <StyledDividerDashed />
              </Grid>
            </Fragment>
          )}
          <Grid item xs={12} sm={4}>
            <Box>
              <div className="wrap-check">
                <Typography
                  className="sub-header-1"
                  variant="body1"
                  gutterBottom
                >
                  {t("WagesLabor")}
                </Typography>
              </div>
              <Typography className="sub-header" variant="body1">
                {t("CalculatePay")}
              </Typography>
              <div>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="round-payroll"
                    name="isPaySalary"
                    value={paymentRoundData.isPaySalary}
                  >
                    <FormControlLabel
                      value="1"
                      control={
                        <Radio disabled={!paymentRoundData.isPaySalary} />
                      }
                      label={t("Yes")}
                    />
                    <FormControlLabel
                      value="0"
                      control={
                        <Radio disabled={!paymentRoundData.isPaySalary} />
                      }
                      label={t("No")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box>
              <div className="wrap-check">
                <Typography
                  className="sub-header-1"
                  variant="body1"
                  gutterBottom
                >
                  {t("OvertimePay")}
                </Typography>
              </div>
              <Typography className="sub-header" variant="body1">
                {t("CalculatePay")}
              </Typography>
              <div>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="round-payroll"
                    name="isPayOT"
                    value={paymentRoundData.isPayOT}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio disabled={!paymentRoundData.isPayOT} />}
                      label={t("Yes")}
                    />
                    <FormControlLabel
                      value="0"
                      control={<Radio disabled={!paymentRoundData.isPayOT} />}
                      label={t("No")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box>
              <div className="wrap-check">
                <Typography
                  className="sub-header-1"
                  variant="body1"
                  gutterBottom
                >
                  {t("ShiftWorkPay")}
                </Typography>
              </div>
              <Typography className="sub-header" variant="body1">
                {t("CalculatePay")}
              </Typography>
              <div>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="round-payroll"
                    name="isPayShiftfee"
                    value={paymentRoundData.isPayShiftfee}
                  >
                    <FormControlLabel
                      value="1"
                      control={
                        <Radio disabled={!paymentRoundData.isPayShiftfee} />
                      }
                      label={t("Yes")}
                    />
                    <FormControlLabel
                      value="0"
                      control={
                        <Radio disabled={!paymentRoundData.isPayShiftfee} />
                      }
                      label={t("No")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Box>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Box>
              <div className="wrap-check">
                <Typography
                  className="sub-header-1"
                  variant="body1"
                  gutterBottom
                >
                  {t("Late")}
                </Typography>
              </div>
              <Typography className="sub-header" variant="body1">
                {t("DeductWages")}
              </Typography>
              <div>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="round-payroll"
                    name="isDeductLateEarly"
                    value={paymentRoundData.isDeductLateEarly}
                  >
                    <FormControlLabel
                      value="1"
                      control={
                        <Radio disabled={!paymentRoundData.isDeductLateEarly} />
                      }
                      label={t("Yes")}
                    />
                    <FormControlLabel
                      value="0"
                      control={
                        <Radio disabled={!paymentRoundData.isDeductLateEarly} />
                      }
                      label={t("No")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className="wrap-check">
              <Typography className="sub-header-1" variant="body1" gutterBottom>
                {t("Absent")}
              </Typography>
            </div>
            <Typography className="sub-header" variant="body1">
              {t("DeductWages")}
            </Typography>
            <div>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="round-payroll"
                  name="isDeductAbsent"
                  value={paymentRoundData.isDeductAbsent}
                >
                  <FormControlLabel
                    value="1"
                    control={
                      <Radio disabled={!paymentRoundData.isDeductAbsent} />
                    }
                    label={t("Yes")}
                  />
                  <FormControlLabel
                    value="0"
                    control={
                      <Radio disabled={!paymentRoundData.isDeductAbsent} />
                    }
                    label={t("No")}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div className="wrap-check">
              <Typography className="sub-header-1" variant="body1" gutterBottom>
                {t("LeaveWOPay")}
              </Typography>
            </div>
            <Typography className="sub-header" variant="body1">
              {t("DeductWages")}
            </Typography>
            <div>
              <FormControl>
                <RadioGroup
                  row
                  aria-labelledby="round-payroll"
                  name="isDeductLeaveWOPay"
                  value={paymentRoundData.isDeductLeaveWOPay}
                >
                  <FormControlLabel
                    value="1"
                    control={
                      <Radio disabled={!paymentRoundData.isDeductLeaveWOPay} />
                    }
                    label={t("Yes")}
                  />
                  <FormControlLabel
                    value="0"
                    control={
                      <Radio disabled={!paymentRoundData.isDeductLeaveWOPay} />
                    }
                    label={t("No")}
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Box>
              <div className="wrap-check">
                <Typography
                  className="sub-header-1"
                  variant="body1"
                  gutterBottom
                >
                  {t("Addition")}
                </Typography>
              </div>
              <Typography className="sub-header" variant="body1">
                {t("CalculatePay")}
              </Typography>
              <div>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="round-payroll"
                    name="isPayAddition"
                    value={paymentRoundData.isPayAddition}
                  >
                    <FormControlLabel
                      value="1"
                      control={
                        <Radio disabled={!paymentRoundData.isPayAddition} />
                      }
                      label={t("Yes")}
                    />
                    <FormControlLabel
                      value="0"
                      control={
                        <Radio disabled={!paymentRoundData.isPayAddition} />
                      }
                      label={t("No")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box>
              <div className="wrap-check">
                <Typography
                  className="sub-header-1"
                  variant="body1"
                  gutterBottom
                  style={{ color: "#FFF" }}
                >
                  {t("Addition")}
                </Typography>
              </div>
              <Typography className="sub-header" variant="body1">
                {t("Prorate")}
              </Typography>
              <div>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="round-payroll"
                    name="prorateAddition"
                    value={paymentRoundData.prorateAddition}
                  >
                    <FormControlLabel
                      value="1"
                      control={
                        <Radio disabled={!paymentRoundData.prorateAddition} />
                      }
                      label={t("Yes")}
                    />
                    <FormControlLabel
                      value="0"
                      control={
                        <Radio disabled={!paymentRoundData.prorateAddition} />
                      }
                      label={t("No")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box>
              <div className="wrap-check">
                <Typography
                  className="sub-header-1"
                  variant="body1"
                  gutterBottom
                >
                  {t("Deduction")}
                </Typography>
              </div>
              <Typography className="sub-header" variant="body1">
                {t("CalculatePay")}
              </Typography>
              <div>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="round-payroll"
                    name="isPayDeduction"
                    value={paymentRoundData.isPayDeduction}
                  >
                    <FormControlLabel
                      value="1"
                      control={
                        <Radio disabled={!paymentRoundData.isPayDeduction} />
                      }
                      label={t("Yes")}
                    />
                    <FormControlLabel
                      value="0"
                      control={
                        <Radio disabled={!paymentRoundData.isPayDeduction} />
                      }
                      label={t("No")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Box>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Box>
              <div className="wrap-check">
                <Typography
                  className="sub-header-1"
                  variant="body1"
                  gutterBottom
                  style={{ color: "#FFF" }}
                >
                  {t("Deduction")}
                </Typography>
              </div>
              <Typography className="sub-header" variant="body1">
                {t("Prorate")}
              </Typography>
              <div>
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="round-payroll"
                    name="prorateDeduction"
                    value={paymentRoundData.prorateDeduction}
                  >
                    <FormControlLabel
                      value="1"
                      control={
                        <Radio disabled={!paymentRoundData.prorateDeduction} />
                      }
                      label={t("Yes")}
                    />
                    <FormControlLabel
                      value="0"
                      control={
                        <Radio disabled={!paymentRoundData.prorateDeduction} />
                      }
                      label={t("No")}
                    />
                  </RadioGroup>
                </FormControl>
              </div>
            </Box>
          </Grid>

          {/* {paymentRoundData.paysilpPublicType === "auto" && (
            <Fragment>
              <Grid item xs={12} sm={6}>
                <Fragment>
                  <div className="wrap-label-switch">
                    <Typography className="item-name">
                      {t("salaryPaymentDate")}
                    </Typography>
                    <StyledFormControlLabelSwitch
                      checked={paymentRoundData.salaryPayNextMonth}
                      control={<Switch size="small" />}
                      label={"เดือนถัดไป"}
                      labelPlacement="nextMonth"
                    />
                  </div>
                  <StyledFormControl fullWidth>
                    <Select
                      MenuProps={MenuProps}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      name="salaryPayDate"
                      value={paymentRoundData.salaryPayDate}
                    >
                      <MenuItem key={99} value={-1}>
                        วันสุดท้ายของเดือน
                      </MenuItem>
                      {[...Array(29).keys()].map((item) => (
                        <MenuItem key={item} value={item + 1}>
                          {item + 1}
                        </MenuItem>
                      ))}
                    </Select>
                  </StyledFormControl>
                </Fragment>
              </Grid>
              <Grid item xs={12} sm={6}>
                <div className="wrap-label-switch">
                  <Typography className="item-name">
                    {t("paySlipReleaseDay")}
                  </Typography>
                  <StyledFormControlLabelSwitch
                    checked={paymentRoundData.paysilpPublicNextMonth}
                    control={<Switch size="small" />}
                    label={"เดือนถัดไป"}
                    labelPlacement="nextMonth"
                  />
                </div>

                <StyledFormControl fullWidth>
                  <Select
                    MenuProps={MenuProps}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="paysilpPublicDate"
                    value={paymentRoundData.paysilpPublicDate}
                  >
                    <MenuItem key={99} value={-1}>
                      วันสุดท้ายของเดือน
                    </MenuItem>
                    {[...Array(29).keys()].map((item) => (
                      <MenuItem key={item} value={item + 1}>
                        {item + 1}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledFormControl>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Typography className="item-name">
                  {t("paySlipTime")}
                </Typography>
                <StyledFormControl fullWidth>
                  <Select
                    inputProps={{ readOnly: true }}
                    MenuProps={MenuProps}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="paysilpPublicTime"
                    value={paymentRoundData.paysilpPublicTime}
                  >
                    {timePayslip.map((item) => (
                      <MenuItem key={item} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </StyledFormControl>
              </Grid>
              
            </Fragment>
          )} */}
        </Grid>
      ) : (
        <div style={{ padding: 24 }}>
          <Typography color="text.third" variant="body1">
            {t("NoSettingInSystem")}
          </Typography>
        </div>
      )}
    </StyledRoot>
  );
};

export default RoundOne;
